module.exports = __webpack_public_path__ + "img/eduloc360.851e6358.png";